// extracted by mini-css-extract-plugin
export default {"effectFill":"style_effectFill__sYJQh"};